// extracted by mini-css-extract-plugin
module.exports = {"tags":"tags-module--tags--3pXhd","tag":"tags-module--tag--3RtOV","delimiter":"tags-module--delimiter--2rGVW","tagList":"tags-module--tagList--I9pB7"};